import { cn } from '@/lib/utils';

import type { ComponentProps } from 'react';

const Marker = ({ className, ...props }: ComponentProps<'div'>) => (
  <div
    data-slot="marker"
    className={cn(
      "group/marker relative flex min-h-4 w-full items-center gap-2 text-left text-sm text-foreground-muted [&_svg:not([class*='size-'])]:size-4 [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:text-foreground",
      className
    )}
    {...props}
  />
);

const MarkerContent = ({ className, ...props }: ComponentProps<'span'>) => (
  <span
    data-slot="marker-content"
    className={cn('min-w-0 break-words', className)}
    {...props}
  />
);

export { Marker, MarkerContent };
